import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=3bef75f0&scoped=true"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=3bef75f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef75f0",
  null
  
)

export default component.exports